import React from 'react';
import { SalesPage } from './pages/SalesPage';
type AppProps = {
  showReviews?: boolean;
  showPurchasePopups?: boolean;
  showCountdown?: boolean;
  showExtrasOffer?: boolean;
  guaranteeEnabled?: boolean;
};
export function App({
  showReviews = true,
  showPurchasePopups = true,
  showCountdown = true,
  showExtrasOffer = false,
  guaranteeEnabled = true
}: AppProps) {
  return <SalesPage showReviews={showReviews} showPurchasePopups={showPurchasePopups} showCountdown={showCountdown} showExtrasOffer={showExtrasOffer} guaranteeEnabled={guaranteeEnabled} data-id="element-0" data-mp="2rkdw2qlx15m6" />;
}